import styled from 'styled-components';
import { darken, rgba } from 'polished';
import { Dialog as MuiDialog } from '@material-ui/core';

const THEME_COLOR = '#6b63d5';

export const Dialog = styled(MuiDialog)`
  .MuiDialog-paper {
    border-radius: 8px;
    overflow: hidden;
    min-width: 600px;
  }

  .MuiDialogTitle-root {
    background: white;
    padding: 24px;
    border-bottom: 1px solid ${rgba('#000', 0.08)};

    h2 {
      font-size: 1.25rem;
      color: ${darken(0.4, THEME_COLOR)};
      font-weight: 600;
      margin: 0;
      display: flex;
      align-items: center;
      gap: 12px;

      i {
        font-size: 1.5rem;
        color: ${THEME_COLOR};
      }
    }
  }

  .MuiDialogContent-root {
    padding: 24px;
    background: ${rgba('#000', 0.02)};

    pre {
      margin: 0;
      padding: 16px;
      background: white;
      border-radius: 6px;
      border: 1px solid ${rgba('#000', 0.1)};
      font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', 'Consolas', monospace;
      font-size: 13px;
      line-height: 1.5;
      white-space: pre-wrap;
      word-break: break-all;
      color: ${rgba('#000', 0.8)};
    }
  }

  .MuiDialogActions-root {
    padding: 16px 24px;
    border-top: 1px solid ${rgba('#000', 0.08)};
    background: ${rgba('#000', 0.02)};
  }
`;

export const Button = styled.button<{ variant?: 'primary' | 'secondary' }>`
  height: 32px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
  padding: 0 16px;
  font-size: 0.9rem;
  font-weight: 500;

  i {
    font-size: 1.2rem;
  }

  ${props => props.variant === 'primary' ? `
    background: ${THEME_COLOR};
    color: white;

    &:hover {
      background: ${darken(0.1, THEME_COLOR)};
    }

    &:disabled {
      background: ${rgba(THEME_COLOR, 0.6)};
      cursor: not-allowed;
    }
  ` : `
    background: white;
    color: ${THEME_COLOR};
    border: 1px solid ${rgba(THEME_COLOR, 0.2)};

    &:hover {
      background: ${rgba(THEME_COLOR, 0.05)};
    }

    &:disabled {
      color: ${rgba(THEME_COLOR, 0.4)};
      border-color: ${rgba(THEME_COLOR, 0.1)};
      cursor: not-allowed;
    }
  `}
`;

export const CopyMessage = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: ${THEME_COLOR};
  font-size: 0.875rem;

  i {
    font-size: 1.1rem;
  }
`;
